/* eslint-disable */
export default `
<html xmlns="http://www.w3.org/1999/xhtml">

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width" />
    <title>Doctor Invitation</title>

    <style type="text/css">
        body {
            background-color: #eef0f4;
        }
        /*////// RESET STYLES //////*/
        body,
        #bodyTable,
        #bodyCell {
            height: 100% !important;
            margin: 0;
            padding: 0;
            width: 100% !important;
        }

        table {
            border-collapse: collapse;
        }

        img,
        a img {
            border: 0;
            outline: none;
            text-decoration: none;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            margin: 0;
            padding: 0;
        }

        p {
            margin: 1em 0;
        }

        /*////// CLIENT-SPECIFIC STYLES //////*/
        .ReadMsgBody {
            width: 100%;
        }

        .ExternalClass {
            width: 100%;
        }

        /* Force Hotmail/Outlook.com to display emails at full width. */
        .ExternalClass,
        .ExternalClass p,
        .ExternalClass span,
        .ExternalClass font,
        .ExternalClass td,
        .ExternalClass div {
            line-height: 100%;
        }

        /* Force Hotmail/Outlook.com to display line heights normally. */
        table,
        td {
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
        }

        /* Remove spacing between tables in Outlook 2007 and up. */
        #outlook a {
            padding: 0;
        }

        /* Force Outlook 2007 and up to provide a "view in browser" message. */
        img {
            -ms-interpolation-mode: bicubic;
        }

        /* Force IE to smoothly render resized images. */
        body,
        table,
        td,
        p,
        a,
        li,
        blockquote {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
        }

        /* Prevent Windows- and Webkit-based mobile platforms from changing declared text sizes. */

        /*////// FRAMEWORK STYLES //////*/

        /*////// GENERAL STYLES //////*/
        #bodyTable {
            max-width: 680px;
        }

        #emailBody {
            background-color: #FFFFFF;
            border-collapse: separate;
            border-radius: 0px;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            color: #202020;
            font-family: Helvetica;
            font-size: 20px;
            line-height: 125%;
            text-align: Left;
        }

        .logo {
            width: 120px;
            height: 28px
        }

        /*////// MOBILE STYLES //////*/
        @media only screen and (max-width: 480px) {

            /*////// FRAMEWORK STYLES //////*/
            table[id="emailBody"],
            table[class="flexibleContainer"] {
                width: 100% !important;
            }


            img[class="flexibleImage"] {
                height: auto !important;
                width: 100% !important;
            }

            table[class="emailButton"] {
                width: 100% !important;
            }

            td[class="buttonContent"] {
                padding: 0 !important;
            }

            td[class="buttonContent"] a {
                padding: 15px !important;
            }

            td[class="textContentLast"],
            td[class="imageContentLast"] {
                padding-top: 20px !important;
            }
        }

        @media only screen and (max-width: 767px) {
           .emailContent {
                padding: 24px 16px !important;
           }
        }

        @media only screen and (min-width: 768px) {

        }

        a {
            text-decoration: unset;
        }
    </style>
    <!--
        	Outlook Conditional CSS
            These two style blocks target Outlook 2007 & 2010 specifically, forcing
            columns into a single vertical stack as on mobile clients. This is
            primarily done to avoid the 'page break bug' and is optional.
            More information here:
			http://templates.mailchimp.com/development/css/outlook-conditional-css
        -->
    <!--[if mso 12]>
            <style type="text/css">
            	.flexibleContainer{display:block !important; width:100% !important;}
            </style>
        <![endif]-->
    <!--[if mso 14]>
            <style type="text/css">
            	.flexibleContainer{display:block !important; width:100% !important;}
            </style>
        <![endif]-->
</head>

<body>
    <center>
        <table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable"
            style="">
            <tr>
                <td align="center" valign="top" id="bodyCell">
                    <!-- EMAIL CONTAINER // -->

                    <table border="0" cellpadding="0" cellspacing="0" width="100%" id="emailBody">


                        <!-- MODULE ROW content // -->

                        <tr>
                            <td align="center" valign="top" style="padding: 24px 56px;" class="emailContent">
                                <!-- CENTERING TABLE // -->

                                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                    <!-- MODULE ROW // -->
                                    <tr>
                                        <td align="center" valign="top">
                                            <!-- CENTERING TABLE // -->
                                            <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                                <tr>
                                                    <td align="center" valign="top">
                                                        <p style="font-size: 1.1em;">
                                                             <strong>ADVISORY FOR PATIENTS ISSUED WITH MEDICAL CERTIFICATES FOR ACUTE RESPIRATORY SYMPTOMS</strong>
                                                             </p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <!-- // CENTERING TABLE -->
                                        </td>
                                    </tr>
                                    <!-- // MODULE ROW -->

                                    <!-- MODULE ROW address  // -->
                                    <tr>
                                        <td align="left" valign="top">
                                            <p>
                                                You have symptoms of an acute respiratory infection and the doctor has issued a medical certificate (MC) for you to recover at home.
                                            </p>
                                            <p>In view of the on-going COVID-19 situation, <strong>you must not leave your home for 5 days starting from the date of your MC</strong>.                                            </p>
                                            <p>Persons who do not comply will be liable to a fine of up to $10,000, or imprisonment up to six months, or both, under the Infectious Diseases Act.</p>
                                            <p><strong>You should only leave your home to seek medical attention.</strong></p>
                                            <p style="margin-bottom: 0;">
                                                <strong>Advice on what you should do:</strong>
                                                <ol style="list-style: circle; margin-top: 0.3em;">
                                                    <li>Stay in a separate room at home if possible, and minimize interaction with your household members.</li>
                                                    <li>Maintain good personal hygiene, including washing your hands with soap and water frequently, avoiding touching your eyes, nose and mouth, and covering your mouth when coughing or sneezing etc.</li>
                                                    <li>Do not share any food, crockery, utensils or other personal hygiene items.</li>
                                                    <li>Take the medications prescribed for you (if any).</li>
                                                    <li>Drink sufficient fluids.</li>
                                                    <li>Continue to monitor your temperature and symptoms at home.</li>
                                                </ol>
                                            </p>
                                            <p style="margin-bottom: 0;">
                                                <strong>If your symptoms worsen:</strong>
                                                <ol style="list-style: circle; margin-top: 0.3em;">
                                                    <li>Call 995 for an ambulance if it is a medical emergency.</li>
                                                    <li>Otherwise, put on a surgical mask and return to the same clinic for a review.</li>
                                                </ol>
                                            </p>
                                            <p style="margin-bottom: 0;">
                                                <strong>Important contact information:</strong>
                                                <ol style="list-style: circle; margin-top: 0.3em;">
                                                    <li>For more clarifications, you can contact the clinic at <strong>+123456789</strong> (contact number).</li>
                                                </ol>
                                            </p>

                                        </td>
                                    </tr>
                                    <!-- // MODULE ROW Address-->
                                </table>
                                <!-- // CENTERING TABLE -->
                            </td>
                        </tr>
                        <!-- // MODULE ROW -->

                    </table>
                    <!-- // EMAIL CONTAINER -->
                </td>
            </tr>
        </table>
    </center>
</body>

</html>
`;
